module.exports = __webpack_public_path__ + "img/btn_link_2.0a4d1d4b.png";